const en = {
  unitsChart: {
    avgIpuDay: 'Avg IPU/day',
    tooltipAvg: 'Avg {avg} IPU/day',
    showService: 'Show {service}',
    hideService: 'Hide {service}',
    showAll: 'Show all services',
    moreServices: 'More services',
    highlight: 'Highlight in this chart',
    filterBy: 'Filter by {service}',
    unfilterBy: 'Remove {service} from filter',
  },
  general: {
    clusterMustBeConnectedToChange:
      'Your cluster must be connected to apply this change',
  },
  systemManagement: {
    toggleFeatures: {
      azureSupport: {
        userModal: {
          title: 'Edit Azure Toggle Feature for User',
          azurePlansDdlLabel: 'Azure clusters plan',
          azurePlansDdlPlaceholder: 'Please select a plan',
          updateBtn: 'Update',
          cancelBtn: 'Cancel',
          freeUserHint: ' Can’t add Azure Plan for Free users',
        },
      },
    },
  },
  userRolesPage: {
    pageTitle: 'User Roles',
    userRoleModal: {
      shouldSelectActionOrPage: 'You must select at least one page',
    },
  },
  clusterConfigurations: {
    autoscaling: {
      wholeNumberValidation: 'Please enter a whole number',
      title: ' Auto Scaling ',
      requestDelay: 'Request Delay (sec)',
      coolDelay: 'Cooldown delay (min)',
      rejectedQueriesUp: 'Rejected queries upscale',
      rejectedQueriesDown: 'Rejected queries downscale',
      consecutiveQueries: 'Consecutive queries',
      status: 'Status: ',
      enabled: 'Enabled',
      disabled: 'Disabled',
      changeAutoscalingHint:
        'Any change will be reflected after enabling the autoscaling',
      hints: {
        requestDelay: 'Time interval between each query [{min} - {max}]',
        coolDelay: 'Delay between each scaling process [{min} - {max}]',
        rejectedQueriesUp:
          'Limit of rejected queries count before scaling up [{min} - {max}]',
        rejectedQueriesDown:
          'Limit of rejected queries count before scaling down [{min} - {max}]',
        consecutiveQueries:
          'Minimum amount of sequential queries before scaling up or down [{min} - {max}]',
      },
    },
  },
  cloudCapacityManagement: {
    pageTitle: 'Cloud Capacity Management',
    tabs: {
      gc: 'Google Cloud',
      azure: 'Azure',
      aws: 'AWS',
    },
    createNewSizeButton: 'Create New Size',
    newSizeModal: {
      title: 'Create New Size',
    },
    sizeModal: {
      title: 'Size "{displayName}" in "{operator}"',
      titleNewSize: 'Create New Size',
    },
    deleteConfirmModal: {
      title: 'Delete Size',
      content:
        'Are you sure you want to delete size {clusterSize} in {operator}?',
      okText: 'Yes',
      cancel: 'Cancel',
    },
  },
  pythonPackagesTag: {
    installing: 'installing',
    failed: 'failed',
    succeeded: 'succeeded',
  },
  clusterPage: {
    createNewCluster: 'Create New Cluster',
    createConsentFlow: 'Configure Azure clusters',
    displayVersions: 'Sync Versions',
    externalBucket: 'External Bucket',
  },
  clusterActions: {
    externalBucket: {
      title: 'External Bucket of cluster <strong>{clusterName}</strong>',
      destinationClusterAlert:
        'Cluster <strong>{clusterName}</strong> is a <i>Destination</i> for <strong>{isClusterADestination}</strong>',
      destinationClusterAlertDescription:
        'You can remove this cluster for being a destination through its source cluster <strong>{isClusterADestination}</strong>',
      dataExtraction: 'Data Extraction: ',
      bucketPath: 'Bucket Path: ',
      copyBucketPath: 'Copy Bucket Path',
      clustersInSameBucket: 'Clusters in the same bucket: ',
      searchClusters: 'Search Clusters',
      addClusterToExternalBucket:
        'Add Cluster to External Bucket as Destination',
      addClusterToExternalBucketButton: 'Add',
      clustersTable: {
        clusterColumn: 'Cluster',
        isDestinationClusterEnabledColumn: 'Enabled',
        removeClusterFromExternalBucketTooltip:
          'Remove Cluster From External Bucket',
        removeClusterFromExternalBucketButton: 'Remove',
      },
    },
  },
  scalingPage: {
    pageTitle: 'Cluster Scaling',
    createNewScalingButton: 'Create new cluster scaling scheduler',
    scalingTable: {
      fields: {
        clusterName: 'Cluster',
        schedule: 'Cron Schedule',
        timezone: 'Timezone',
        event: 'Action',
        eventInformation: 'Target Configuration',
        createdBy: 'Created By',
        createdAt: 'Created At',
        status: 'Status',
      },
    },
    scalingModal: {
      title: {
        new: 'New Scaling Event',
      },
      buttons: {
        create: 'Create',
        cancel: 'Cancel',
      },
      confirmation: {
        title: 'Are you sure?',
        content: 'This action will schedule a new scaling event.',
        okText: 'Yes, Create',
        cancelText: 'Cancel',
      },
      error: 'Something went wrong while fetching user role data.',
      loading: 'Loading scaling modal...',

      fields: {
        clusterName: 'Cluster Name',
        schedule: 'Schedule (Cron)',
        event: 'Event Type',
        replicaType: 'Replica Type',
        replicaCount: 'Replica Count',
        subclusterReplicaCount: 'Subcluster Replica Count',
        notes: 'Notes',
      },
      tooltips: {
        clusterName: 'Search and select a target cluster',
        schedule:
          'Specify a cron schedule for the scaling event (e.g. 0 * * * *)',
        event:
          'Specify whether to Scale Up, Scale Down or Connect/Disconnect subcluster',
        replicaType: 'Choose which type of replicas to scale',
        replicaCount: 'How many replicas should be set',
        notes: 'Optional notes for this event',
      },
      validation: {
        required: '{field} is required',
        replicaMin: 'Replica count must be at least 1',
      },
    },
  },
  createNewSubClusterModal: {
    description:
      'Set the name, size and type to create your Self-Managed Cluster, all other configurations are inherited from the main cluster.',
    scaleDescription:
      'Easily adjust the resources allocated to your services with this intuitive scaling tool. Use the controls to increase or decrease the number of service instances based on your workload needs.',
    nodesFieldLabel: 'Services',
    nodesFieldHint:
      'View the current services count and Apply scaling adjustments with a single click.',
    nameFieldLabel: 'Name',
    nameFieldPlaceholder: 'Incorta-101',
    nameFieldHint: {
      gc: 'Self-Managed Cluster name can be a minimum of 3 characters long (Alphabet english letters, numbers, dashes or combination), no spaces are allowed, can’t start with numbers and can’t begin or end with dash. Example: incorta-101.',
      azure:
        'Self-Managed Cluster name can be a minimum of 3 characters long (English lowercase alphanumerics) and maximum of 8 characters.',
    },
    sizeFieldLabel: 'Size',
    sizeFieldPlaceholder: 'Select a Size',
    typeFieldLabel: 'Type',
    typeFieldConfig: 'Extra Configs',
    typeFieldError: 'Type is required',
    typeFieldPlaceholder: 'Select a Type',
    saveButton: 'Save',
    createButton: 'Create',
    cancelButton: 'Cancel',
    selfManagedClusterNameRequired: 'Please input Self-Managed Cluster Name!',
  },
  partnersPage: {
    pageTitle: 'IncortaOne Partners',
    createNewPartnerButton: 'Create new IncortaOne Partner',
    partnersTable: {
      fields: {
        name: 'Partner Name',
        email: 'Email',
        createdat: 'Created At',
      },
    },
    partnersModal: {
      gettingPartnersData: 'Getting IncortaOne Partners',
      title: {
        newPartner: 'New IncortaOne Partner',
        editPartner: 'Edit Partner',
      },
      fields: {
        name: 'Name',
        partnerEmail: 'Email',
        clustersCount: 'Clusters Count',
        maxCPU: 'Max CPU / Cluster',
        maxMemory: 'Max Memory / Cluster',
        platforms: 'Platform',
        clustersDefaultSize: 'Clusters Default Size',
        allowMLflow: 'MLflow',
        allowSQLX: 'SQLX',
      },
      buttons: {
        create: 'Create',
        update: 'Update',
        cancel: 'Cancel',
        next: 'Next',
      },
      somethingWentWrong: 'Something Went Wrong',
    },
  },
  consumptionPage: {
    pageTitle: 'Consumption',
    createNewConsumptionButton: 'New Augmentation',
    consumptionTable: {
      fields: {
        clusterName: 'Cluster Name',
        startTime: 'Start Time',
        endTime: 'End Time',
        consumptionType: 'Consumption Type',
        actionType: 'Action Type',
        powerUnit: 'IPU Value',
        notes: 'Notes',
        createdBy: 'Created By',
        createdAt: 'Created At',
      },
    },
    consumptionModal: {
      title: {
        new: 'New Consumption',
        edit: 'Edit Consumption',
      },
      fields: {
        clusterName: 'Cluster Name',
        startDate: 'Start Date',
        endDate: 'End Date',
        consumptionType: 'Consumption Type',
        actionType: 'Action Type',
        value: 'Value',
        notes: 'Notes',
      },
      tooltips: {
        clusterName: 'Select the target cluster for augmentation.',
        startDate: 'Choose when the augmentation starts.',
        endDate:
          'Choose when the augmentation ends. End date must be after start date.',
        consumptionType:
          'Specify whether this applies to Incorta or Spark usage.',
        actionType:
          'Choose to add/remove fixed IPUs or adjust by multiplying consumption.',
        value:
          'Add: +5 or -5 IPUs. Adjust: 1.5 (increase by 50%), 0.5 (reduce by 50%).',
        notes: 'Explain the reason for the augmentation.',
      },
      validation: {
        required: '{field} is required',
        dateRange: 'Start Date must be before or equal to End Date.',
        valueNumber: 'Value must be a number.',
        valueNonZero: 'Value cannot be 0 and should not equal 1',
        adjustPositive: 'Adjust value must be > 0.',
      },
      buttons: {
        create: 'Create',
        update: 'Update',
        cancel: 'Cancel',
      },
      somethingWentWrong: 'Something went wrong',
      confirmation: {
        title: 'Confirm Submission',
        content:
          'Are you sure you want to submit this consumption modification?',
        okText: 'Yes, submit',
        cancelText: 'Cancel',
      },
    },
  },
  knowIncortaBanner: {
    incortaCommunity: 'Incorta Community',
    join: 'Join',
    incortaOverview: 'Incorta Overview Demo',
    watch: 'Watch',
    incortaDocumentation: 'Incorta Documentation',
    freeTraining: 'Free Training',
    start: 'Start',
  },
  clusterServerConfigurationList: {
    title: 'SQL Interface for External BI Tools',
  },
  clustersPage: {
    clusterTypes: {
      incortaCluster: 'Incorta cluster',
      azureCluster: 'Azure cluster',
    },
  },
  consentFlow: {
    formTitle: 'Configure your Azure clusters',
    formSubtitle: "Only one step and you're good to go!",
    envName: 'Environment Name',
    envNamePlaceholder: 'Incorta',
    envNameTooltip:
      "We'll create two clusters (environments) based on this name—one for development and one for production (e.g., Incorta-DEV and Incorta-PROD).",
    envNameRequired: 'Please enter a valid environment name.',
    envNameMinimumCount: 'Name must be at least 3 characters.',
    envNameMaximmumCount: 'Name cannot be longer than 8 characters.',
    azureSubID: 'Azure Subscription ID',
    azureSubIDPlaceholder: '00000000-0000-0000-0000-000000000000',
    azureRG: 'Azure Resource Group Name',
    azureRGPlaceholder: 'Resource Group Name',
    azureRGTooltip:
      'Incorta recommends creating the resource group in the same location as the resources region.',
    resourceGroupRequired: 'Please enter your Azure Resource Group Name.',
    resourceRegionSelection: 'Resources Region Selection',
    resourceRegionSelectionPlaceholder: 'Select',
    subIDRequired: 'Please enter your Azure Subscription ID.',
    subIDValidRequired:
      'Please enter a valid subscription ID. It must match the format 00000000-0000-0000-0000-000000000000 and it only accepts alphanumeric characters.',
    subCredRequired: 'Please enter Azure Subscription Information Output.',
    azureSubscriptionInfoOutputPlaceholder: 'Paste output here',
    resourceRegionSelectionRequired: 'Please select a Resource Region.',
    azureCloudShell: 'Azure Cloud Shell',
    commandRequiredGoTo: 'Go to ',
    commandRequiredRun: ' and run the following command: ',
    commandRequiredTooltip:
      'Copy the following command and run it on {azureCloudShell}, then paste the output under Azure subscription information.',
    spCommand: `az ad sp create-for-rbac --name IncortaSP-<Environment name> --role owner --scopes /subscriptions/<subscription_id>/resourceGroups/<resourcegp_name>`,
    azureCommandCopyTooltip: 'Copy Command',
    azureCommandCantCopyTooltip:
      'In order to copy, please make sure to enter a valid environment name, subscription ID, and resource group name.',
    azureCommandCopySuccessful: 'Azure Command has been copied successfully.',
    networks: 'Networks',
    networksTooltip:
      'Use one of the existing networks you have, or let Incorta provide a new network.',
    newNetwork: 'New Network',
    existingNetwork: 'Existing Network',
    networkName: 'Network Name',
    networkNameTooltip: 'Provide the name of your existing virtual network',
    networkNameRequired: 'Please enter a Network Name.',
    addYourNetworkSubnets: 'Add your Network Subnets',
    subnets: {
      subnetRequiredAsterisk: '* ',
      incortaSubnet: 'Incorta Subnet',
      subnetPlaceholderPrefix: 'Example: ',
      incortaSubnetPlaceholder: '172.16.0.0/14',
      sparkSubnet: 'Spark Subnet',
      sparkSubnetPlaceholder: '172.20.0.0/14',
      publicSubnet: 'Public Subnet',
      publicSubnetPlaceholder: '172.24.0.0/24',
      databaseSubnet: 'Database Subnet',
      databaseSubnetPlaceholder: '172.24.1.0/24',
      loadbalancerSubnet: 'Load Balancer Subnet',
      loadbalancerSubnetPlaceholder: '172.24.2.0/24',
    },
    networkSubnetsRequired: 'Please complete the Network Subnets',
    networkConnectionSuccessful: 'Network Connection Test successful',
    networkConnectionFailed: 'Network Connection Test failed',
    cancelButton: 'Cancel',
    submitButton: 'Submit',
    submittingStatus: {
      validating: 'Validating...',
      validationSuccessful: 'Validation successful',
    },
    submissionSuccess:
      'Deploying Incorta on your Azure subscription has started. Please wait 45-50 minutes for your clusters creation.',
    submissionError: 'Something went wrong. Please try again.',
  },
  cloneModal: {
    submitButton: 'SUBMIT',
    cancelButton: 'Cancel',
    clonedClusterNameFieldLabel: 'CLONED CLUSTER NAME',
    successMessage: 'cluster is cloned successfully',
    clonedClusterNameRequired: 'Please input your Cloned Cluster Name',
  },
  clusterForm: {
    clusterName: 'Cluster Name',
    clusterNameHint: {
      gc: 'Cluster name can be a minimum of 3 characters long (letters, numbers, or dashes), no spaces, can’t start with a number or dash, and can’t begin or end with a dash. Example: incorta-101.',
      'az-saas':
        'Cluster name must be 3–10 lowercase letters and numbers only, starting with a letter. Example: incorta.',
      aws: 'Cluster name can only contain letters and numbers (no dashes or spaces), and cannot start with a number. Example: Incorta101.',
      oci: 'Cluster name can be a minimum of 3 characters long (letters, numbers, or dashes), no spaces, can’t start with a number or dash, and can’t begin or end with a dash. Example: incorta-101.',
    },
    clusterNameError: {
      reservedWord:
        'Cluster name cannot contain reserved words: ‘create’, ‘zookeeper’, or ‘loader’.',
      spaces: 'Cluster name cannot contain spaces.',
      startsWithNumber: 'Cluster name cannot start with a number.',
      startsWithDash: 'Cluster name cannot start with a dash.',
      endsWithDash: 'Cluster name cannot end with a dash.',
      consecutiveDashes: 'Cluster name cannot contain consecutive dashes.',
      lowercaseOnly:
        'Cluster name must contain lowercase letters and numbers only.',
      tooShort: 'Cluster name must be at least {min} characters long.',
      tooLong: 'Cluster name must be at most {max} characters long.',
      invalidCharacters: 'Cluster name contains invalid characters.',
    },
    clusterNameInvalid: 'Invalid cluster name. Please follow the naming hint.',
    clusterNameRequired: 'Please input your Cluster Name!',
    clusterNamePlaceholder: 'Cluster Name',
    clusterDiskSizeLabel: 'Disk Size',
    clusterDiskSizeRequired: 'Please input your Disk Size',
    clusterDiskSizePlaceholder: 'Disk Size',
    clusterSizeLabel: 'Cluster Size',
    clusterSizeRequired: 'Please select your Size!',
    clusterSizeExtra: `IPU refers to Incorta Power Units. 1 IPU equals an n2-highmem-8 (8 vCPU × 64 GB) at {cost}/mo in this region.`,
    clusterVersionLabel: `Incorta Version`,
    clusterRegionLabel: `Cluster Region`,
    clusterVersionRequired: 'Please select your Incorta Version!',
    clusterRegionRequired: 'Please select your Cluster Region!',
    clusterVersionPlaceholder: 'Select your Incorta Version',
    clusterRegionPlaceholder: 'Select your Cluster Region',
    clusterTenantLabel: 'Tenant Content',
    clusterTenantRequired: 'Please select your Tenant Content!',
    clusterTenantPlaceholder: 'Select your Tenant Content',
    clusterInstallationLabel: 'Installation',
    clusterInstallationRequired: 'Please select Incorta installation type!',
    clusterInstallationPlaceholder: 'Select your Installation',
    clusterAliveLabelTitle: 'Keep alive',
    clusterAliveLabelHint:
      'After a period of inactivity the cluster will sleep, turn on to keep it alive.',
    clusterPythonPackagesLabel: 'REQUIRED PYTHON PACKAGES',
    clusterPythonPackagesExtra:
      'Should only contain Python packages which are compatible with pip.',
    clusterPythonPackagesPlaceholder: '"Ex: pandas, numpy"',
    clusterCreateButton: 'Create',
    clusteCancelButton: 'Cancel',
    clusterDataAppLabel: 'Data App (Tenants)',
  },
  region: {
    'asia-east1': 'Asia-East1 (Taiwan)',
    'asia-east2': 'Asia-East2 (Hong Kong)',
    'asia-northeast1': 'Asia-Northeast1 (Tokyo)',
    'asia-northeast2': 'Asia-Northeast2 (Osaka)',
    'asia-northeast3': 'Asia-Northeast3 (Seoul)',
    'asia-south1': 'Asia-South1 (Mumbai)',
    'asia-south2': 'Asia-South2 (Delhi)',
    'asia-southeast1': 'Asia-Southeast1 (Singapore)',
    'asia-southeast2': 'Asia-Southeast2 (Jakarta)',
    'australia-southeast1': 'Australia-Southeast1 (Sydney)',
    'australia-southeast2': 'Australia-Southeast2 (Melbourne)',
    'europe-central2': 'Europe-Central2 (Warsaw)',
    'europe-north1': 'Europe-North1 (Finland)',
    'europe-west1': 'Europe-West1 (Belgium)',
    'europe-west2': 'Europe-West2 (London)',
    'europe-west3': 'Europe-West3 (Frankfurt)',
    'europe-west4': 'Europe-West4 (Netherlands)',
    'europe-west6': 'Europe-West6 (Zurich)',
    'northamerica-northeast1': 'Northamerica-Northeast1 (Montréal)',
    'northamerica-northeast2': 'Northamerica-Northeast2 (Toronto)',
    'southamerica-east1': 'Southamerica-East1 (São Paulo)',
    'us-central1': 'US-Central1 (Iowa)',
    'us-east1': 'US-East1 (South Carolina)',
    'us-east4': 'US-East4 (N. Virginia)',
    'us-west1': 'US-West1 (Oregon)',
    'us-west2': 'US-West2 (Los Angeles)',
    'us-west3': 'US-West3 (Salt Lake City)',
    'us-west4': 'US-West4 (Las Vegas)',
  },
  auth0: {
    emailSent: {
      pageTitle: 'Check your inbox!',
      matchingEmail:
        'We just sent you an email to verify your email address. Select the button in the email, and you’re all set!',
      cantFindEmail: 'Can’t find it? ',
      resendEmail: 'Resend the email',
      or: ' or ',
      contactSupport: 'Contact incorta Support',
      returnToHomePage: 'Return to Homepage',
    },
    errorPages: {
      general: {
        returnToLoginPageButton: 'Return to login page',
      },
      blockedUser: {
        headerLine1: 'Your account is blocked!',
        headerLine2: ' ',
        contactSupport: 'Contact us',
        subheader: '  to unblock it.',
      },
      trialExpired: {
        headerLine1: 'Your Trial Expired!',
        headerLine2: 'Want to Extend It?',
        contactSupport: 'Contact Support',
        subheader: ' to extend your trial and explore Incorta further.',
      },
      noAdminAccess: {
        header:
          "You don't have permission to login to the administration portal.",
        signingOut: 'Taking you back to the login page…',
      },
      mfaRequired: {
        headerLine1: 'Multifactor authentication required',
      },
    },
  },
  rolesTag: {
    customRoles: 'Custom Roles',
    multiRoles: 'Multi Roles',
  },
  cmcPasswordModal: {
    userSelectLabel: 'Select CMC User',
    passwordLabel: 'CMC Password',
    passwordPlaceholder: 'Enter or generate a new password',
    generateTooltip: 'Generate a strong random password',
    generateButton: ' Generate Password',
    changeButton: 'Change Password',
    info: 'The cluster owner will receive an email with the new password.',
    chidoriNote:
      'Note: The Chidori password will also be updated to match the new CMC password.',
    generated: 'New password generated successfully!',
    generateFailed: 'Failed to generate password.',
    emptyPasswordWarning: 'Please enter a password.',
    passwordUpdated: 'CMC password updated successfully!',
    passwordUpdateFailed: 'Failed to update CMC password.',
  },
  dynamicAdvancedSearch: {
    searchFieldKey: 'Search By',
    searchFieldValue: 'Value',
    removeSearch: 'Remove',
    addSearch: 'Add',
    disabledBtnTooltip: 'Fill all the search fields',
  },
};
export default en;
